import type { AdminJsonComponentConfig } from '@apps/websiteCustomJsonComponents/types';
import { CustomComponentsWrapperType } from '@website-editor/customComponents/CustomComponents';
import { AdminSidebarComponentProps } from './JsonComponent.types';
import React, { Suspense } from 'react';
import { createComponentHealth } from '@shared/components/ComponentHealth';

type CustomComponentWrapperProps = AdminSidebarComponentProps & { component: AdminJsonComponentConfig };

const [wrapWithCustomJsonComponentHealth] = createComponentHealth('CustomJsonComponent');

const TIMEOUT_MS = 10000;

/**
 * Renders the appropriate state for a CustomJsonComponent
 */
const CustomComponentWrapperInner = (props: CustomComponentWrapperProps) => {
  const { component, wrapperType } = props;

  let ComponentToRender: React.ComponentType<AdminSidebarComponentProps>;

  switch (wrapperType) {
    case CustomComponentsWrapperType.AddComponentList: {
      ComponentToRender = component.adminSidebarComponent.addComponentView;
      break;
    }
    case CustomComponentsWrapperType.EditComponentList: {
      ComponentToRender = component.adminSidebarComponent.dragComponentView;
      break;
    }
    default:
    case CustomComponentsWrapperType.SingleComponent: {
      if (props.isEditMode) {
        ComponentToRender = component.adminSidebarComponent.editComponentView;
      } else {
        ComponentToRender = component.adminSidebarComponent.createComponentView;
      }
      break;
    }
  }

  return (
    <Suspense fallback={null}>
      <ComponentToRender {...props} />
    </Suspense>
  );
};

const WrappedComponent = wrapWithCustomJsonComponentHealth(CustomComponentWrapperInner);

export const CustomComponentWrapper = (props: CustomComponentWrapperProps) => (
  <WrappedComponent
    {...props}
    timeout={TIMEOUT_MS}
  />
);
